// src/components/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from './api';
import { TextField, Button, Card, CardContent, Typography, CircularProgress } from '@mui/material';

export const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const tokenData = await login(username);
      onLogin(username, tokenData.access_token, tokenData.token_type || 'bearer');
      navigate('/analytics', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Card style={{ padding: '2rem', width: '300px' }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>Login</Typography>
          {error && (
            <Typography color="error" style={{ marginBottom: '1rem' }}>
              {error}
            </Typography>
          )}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Auth Code"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{ marginBottom: '1rem' }}
              disabled={loading}
            />
            <Button 
              fullWidth 
              variant="contained" 
              color="primary" 
              type="submit"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Login'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
